import { escapeHtml } from 'assets/js/misc';

angular.module('logbook')
  .controller('template-chart', ['$scope', '$rootScope', '$http', '$location', '$window', '$q', '$filter', '$timeout', '$sanitize', '$route',
      function($scope, $rootScope, $http, $location, $window, $q, $filter, $timeout, $sanitize, $route) {
        
     $scope.chartData = [];
     $scope.timestamps = [];
     $scope.axes={};
     $scope.dateTimeOptions = {
         "format": "l",
         "useStrict": true,
         "keepInvalid": true,
         "focusOnShow": false
     };
     $scope.removedSeries = {};
     $scope.removedSections = {};
     $scope.dataRefreshes = [];
     $scope.customLabels = {};

     $scope.$watch('selectedLog', function(newVal, oldVal) {
        if( !newVal && oldVal )
        {
           var logId = $location.search()['log'];
           $location.url('/notes');
           $location.search('log', logId);
        }
     });
     
     $scope.$watch(function() {
        return $location.search()['report'];
     }, function(newVal, oldVal) {
        if( newVal && newVal != oldVal )
           $route.reload();
     });

     if ($location.search()['report']) {
         $scope.segmentPromise = $scope.$parent.reportPromise.then(function() {
            if ($scope.report.template) {
               return $http.get('/api/templateSegments', {
                  noIndicator: true,
                  params: {
                     'template': $scope.report.template.id,
                     'type.name': ['Numeric Input','Text Choice','Sub Template','User Chooser','Checkbox','Tag Choice','Signoff'],
                     'obsolete': false,
                     'sort': 'sortOrder'
                  }
               });
            } else {
               return { data: { _embedded: { templateSegments: [] } } };
            }
        });
     } else {
         $scope.segmentPromise = $http.get('/api/templateSegments', {
            noIndicator: true,
            params: {
               'template': $location.search()['template'],
               'type.name': ['Numeric Input','Text Choice','Sub Template','User Chooser','Checkbox','Tag Choice','Signoff'],
               'obsolete': false,
               'sort': 'sortOrder'
            }
         });
      }
     $scope.segmentPromise.then(function(result) {
        $scope.segments = result.data._embedded.templateSegments;
        $scope.segmentMap = {};
        $scope.segments.forEach(function(segment) {
           $scope.segmentMap[segment.id] = segment;
        });
     });
     
     $scope.abChoicePromise = $http.get('/api/choiceListItems', {
        noIndicator: true,
        params: {
           'list.log': $scope.selectedLog.id,
           'abnormal': true,
           'size':10000
        }
     });
     
     $scope.abChoicePromise.then(function(result) {
        $scope.abnormalChoices = {};
        result.data._embedded.choiceListItems.forEach(function(item) {
           if( !$scope.abnormalChoices[item.listId])
              $scope.abnormalChoices[item.listId] = {};
           $scope.abnormalChoices[item.listId][item.value] = true;
        });
     });
     
     $scope.removeSegment = function(segment)
     {
        var idx = $scope.selectedSegments.indexOf(segment);
        $scope.selectedSegments.splice(idx, 1);
        delete $scope.axes[segment];
        if (!$location.search()['report']) 
            $scope.updateSearch();
        $scope.runQueries();
        $scope.removeChartIfAllCleared();
     }
     
     $scope.addSegment = function()
     {
        $scope.selectedSegments.push($scope.segmentToAdd);
        if( $scope.newSegmentAxis )
           $scope.axes[$scope.segmentToAdd] = $scope.newSegmentAxis;
        delete $scope.segmentToAdd;
        delete $scope.newSegmentAxis;
        $scope.updateSearch();
        $scope.runQueries();
     }
     $scope.updateTime = function()
     {
        $scope.dtFromInvalid = false;
        $scope.dtToInvalid = false;
        if( !$scope.init )
           return;
        $scope.dtFromInvalid = !($scope.dtFrom instanceof moment)
           || !$scope.dtFrom.isValid();
        $scope.dtToInvalid = !($scope.dtTo instanceof moment)
           || !$scope.dtTo.isValid();
        if( $scope.dtFromInvalid || $scope.dtToInvalid )
           return;
        $scope.updateSearch();
        $scope.runQueries(true);
     };
     
     $scope.getContainedSegments = function(section)
     {
        if( section == -1 )
           return $scope.segments;
        return $scope.segments.filter(function(segment) {
           return segment.longName.indexOf($scope.segmentMap[section].longName) == 0
             && segment.id != $scope.segmentMap[section].id;
        });
     }
     
     $scope.getSegmentLevel = function(segmentId)
     {
        return $scope.segmentMap[segmentId].longName.split(';').length - 1;
     };
     $scope.updateSearch = function()
     {
        if (!$location.search()['report'])
            $location.search('templateSegment', $scope.selectedSegments.concat([]));
        if( $scope.dtFrom )
           $location.search('dtFrom', $scope.dtFrom.toISOString())
           .search('dtTo', $scope.dtTo.toISOString());
        Object.keys($scope.axes).forEach(function(segment) {
           if( $scope.axes[segment] )
              $location.search('axis'+segment, $scope.axes[segment]);
           else
              $location.search('axis'+segment, null);
        });
        Object.keys($scope.unitAxisMap).forEach(function(units) {
           if( $scope.unitAxisMap[units] )
              $location.search('axis-'+units, $scope.unitAxisMap[units]);
           else
              $location.search('axis-'+units, null);
        });
     }
     $scope.refreshData = function()
     {
        $scope.init = false;
        var params = {
           "template": $location.search()['template'],
           "sort": "noteTime",
           "projection": "noteProjectionWithFastTemplateValues",
           "templateValueQuery": []
        };
        if( $scope.dtFrom )
           params['noteQuery'] = "noteTime >= '" + $scope.dtFrom.toISOString()
           + "' and noteTime <= '" + $scope.dtTo.toISOString() + "'";
        if( $scope.reportId )
           params['report'] = $scope.reportId;
        
        $scope.keyValues.forEach(function(keyVal) {
           var valueField = 'string_value';
           var query = 'note =hasTemplateValue=("ts_id == ' + keyVal.templateSegmentId;
           if( keyVal.numericValue != null )
              query += ' and numeric_value == ' + keyVal.numericValue + ' ';
           keyVal.tagValues.forEach(function(tag) {
              query += ' and tv_id == ' + tag.id
           });
           if( keyVal.stringValue != null )
           {
              if( keyVal.stringValue.indexOf('"') >= 0
                    || keyVal.stringValue.indexOf("'") >= 0 )
                 throw new Error("Key value contains a quote: " + keyVal.stringValue + '.\n\n'
                       + 'This is not currently supported.');
              query += ' and string_value == \'' + keyVal.stringValue + '\'';
           }
           if( keyVal.userValue != null )
              query += ' and user_id ==' + keyVal.userValue.id;
              
           query += '")';
           params['templateValueQuery'].push(query);
        });
        var res = $http.get('/api/notes', {
           noIndicator: true,
           params: params
        });
           
        res.then(function(result) {
           var notes = result.data._embedded.notes;
           $scope.noteMap = {};
           notes.forEach(function(note) {
              $scope.noteMap[note.id] = note;
              var parsedDate = new Date(note.noteTime.replace(/\+0000/,'Z'));
              if( $scope.timestamps.indexOf(parsedDate) < 0 )
                 $scope.timestamps.push({'timestamp':parsedDate,'noteHref':note._links.self.href});
           });
           $scope.timestamps.sort(function(a,b) {
              return a.timestamp.getTime() - b.timestamp.getTime();
           });
        });
        
        return res;
     };
     
     var templateItemType;
     if( $location.search()['report'])
        templateItemType = 'report';
     else
        templateItemType = 'template';
     
     if (!$location.search()['report'] && $location.search()[templateItemType]) {
         $scope.templatePromise = $http.get('/api/'+templateItemType+'s/' + $location.search()[templateItemType], {
            noIndicator: true,
            params: {
               'projection': templateItemType+'Projection'
            }
         });
     
         $scope.templatePromise.then(function(result) {
            if( templateItemType == 'template' )
               $scope.template = result.data;
            else
            {
               $scope.template = result.data.template;
               $scope.report = result.data;
               
            }
         });
      }
     

     var d = $q.defer();
     if($location.search()['note'])
     {
        var initPromises = [];
        initPromises.push(
           $http.get('/api/notes/'+$location.search()['note'], {
              noIndicator: true,
              params: {
                 'projection': 'noteProjection'
              }
           }));
        initPromises.push(
              $http.get('/api/noteTemplateValues', {
                 noIndicator: true,
                 params: {
                    'note' : $location.search()['note'],
                    'templateSegment.key': true,
                    'sort': 'templateSegment.sortOrder'
                 }
              }));
        
        $q.all(initPromises).then(function(results) {
           var note = results[0].data;
           var parsedDate = new Date(note.noteTime.replace(/\+0000/,'Z'));
           d.resolve( {
              'date': parsedDate,
              'keyValues': results[1].data._embedded.noteTemplateValues
           });
     })
     
     }
     else
     {
        d.resolve({
           'date': new Date(),
           'keyValues': []
        });
     }
     
     d.promise.then(function(noteInfo) {
        var parsedDate = noteInfo['date'];
        $scope.keyValues = noteInfo['keyValues'];
        $scope.calculateKeyIndicator();
        if( $location.search()['dtFrom'] && $location.search()['dtTo'])
        {
           $scope.dtFrom = new Date($location.search()['dtFrom']);
           $scope.dtTo = new Date($location.search()['dtTo']);
        }
        else if( $location.search()['report'])
           $scope.reportId = $location.search()['report'];
        else
        {
           $scope.dtFrom = new Date(parsedDate.getTime());
           $scope.dtFrom.setDate(parsedDate.getDate() - 14);
           $scope.dtFrom.setHours(0,0,0,0);
           
           $scope.dtTo = new Date(parsedDate.getTime());
           $scope.dtTo.setDate(parsedDate.getDate() + 1);
           $scope.dtTo.setHours(0,0,0,0);
        }
     
         $scope.segmentPromise.then($scope.runQueries);
     });
      
     $scope.calculateKeyIndicator = function()
     {
        $scope.keyIndicator = '';
        if( $scope.keyValues )
           $scope.keyValues.forEach(function(keyVal) {
              $scope.keyIndicator += !$scope.keyIndicator.length ? ' - ' : ', ';
              if( keyVal.stringValue )
                 $scope.keyIndicator += keyVal.stringValue;
              if( keyVal.numericValue != null )
                 $scope.keyIndicator += keyVal.numericValue;
              for( var i=0; i < keyVal.tagValues.length; i++ )
                 $scope.keyIndicator += keyVal.tagValues[i].stringValue
                    + (i < keyVal.tagValues.length-1 ? ', ' : '');
              if( keyVal.userValue )
                 $scope.keyIndicator += keyVal.userValue.firstName + ' ' + keyVal.userValue.lastName;
           });
     }
     $scope.newSegmentFilter = function(item)
     {
        if( !$scope.selectedSegments )
           return true;
        if( $scope.selectedSegments.indexOf(-1) >= 0 )
           return false;
        for( var i=0; i < $scope.selectedSegments.length; i++ )
        {
           var selectedSeg = $scope.segmentMap[$scope.selectedSegments[i]];
           if( !item || !item.longName || !selectedSeg || item.longName.indexOf(selectedSeg.longName) == 0 )
              return false;
        }
        return $scope.selectedSegments.indexOf(item.id) < 0;
     }
     $scope.calculateTitle = function()
     {
        if( $scope.report )
        {
           $scope.chartTitle = ' - ' + $scope.report.name;
           return;
        }
        $scope.chartTitle = '';
        if( $scope.expandedSelectedSegments.length == 0 )
           return;
        var sections = [];
        for( var i=0; i < $scope.expandedSelectedSegments.length; i++)
           sections[i] = $scope.segmentMap[$scope.expandedSelectedSegments[i]].longName.split('; ');
        var matchingSections = 0;
        var stop=false;
        for( var i=0; i < sections[0].length-1 && !stop; i++ )
        {
           for( var j=1; j < $scope.expandedSelectedSegments.length; j++ )
           {
              if( sections[j][i] !== sections[0][i])
              {
                 stop = true;
                 break;
              }
           }
           if( !stop )
           {
              matchingSections++;
              if( $scope.chartTitle.length == 0 )
                 $scope.chartTitle = ' -';
              else
                 $scope.chartTitle += ';';
              $scope.chartTitle += ' ' + sections[0][i];
           }
        }

     };

     $scope.runQueries = function(updateData, reportChartInputs) {
        if (reportChartInputs) 
            $scope.reportChartInputs = reportChartInputs;
        else if ($scope.reportChartInputs) {
           reportChartInputs = $scope.reportChartInputs;
           updateData = false;
        } 
        $scope.timestamps.length=0;
        $scope.chartData.length=0;
        $scope.axes = {};
        $scope.unitAxisMap = {};
        $scope.segmentColors = {};
        $scope.dataSeries = {};
        $scope.removedSeries = {};
        $scope.removedSections = {};

        var selectedTs = [],
            ts = reportChartInputs ? reportChartInputs.templateSegmentIds : [];

        if(!reportChartInputs && $location.search()['templateSegment'])
        {
           var tsIds = [].concat($location.search()['templateSegment'])
              .map(function(s){return parseInt(s);});
           var i=0;
           tsIds.forEach(function(segmentId) {
              var segment = $scope.segmentMap[segmentId];
              if( !segment && segmentId != -1 )
                 return;
              selectedTs.push(segmentId);
              var isEntireTemplate = -1 == segmentId;
              if( isEntireTemplate || segment.type.name == 'Sub Template' )
              {
                 $scope.segments.filter(function(seg) {
                    return (isEntireTemplate || seg.id != segment.id)
                       && seg.type.name != 'Sub Template'
                       && (isEntireTemplate || seg.longName.indexOf(segment.longName) == 0);
                 }).forEach(function(seg) {
                    ts.push(seg.id);
                 });
              }
              else
              {
                 ts.push(segmentId);
              }
              i++;
           });
        }
        $scope.selectedSegments = reportChartInputs ? ts : selectedTs;
        $scope.expandedSelectedSegments = ts;
        
        if( updateData )
        {
           $scope.dataRefreshes.length=0;
           $scope.dataRefreshes.push($scope.refreshData());
           $scope.dataRefreshes.push($scope.templatePromise);
           $scope.dataRefreshes.push($scope.abChoicePromise);
        }

        $q.all($scope.dataRefreshes).then(function(results) {
           $scope.calculateTitle();
           var colors = nv.utils.defaultColor();
           
           $scope.axes = {};
           var axisRe = new RegExp('^axis[0-9]+$');
           var unitsRe = new RegExp('^axis-.+$');
           Object.keys($location.search()).forEach(function(key) {
              if( axisRe.test(key) )
              {
                 var tsId = parseInt(key.substring(4));
                 var segmentObj = $scope.segmentMap[tsId];
                 $scope.axes[tsId] = $location.search()[key];
              }
              else if( unitsRe.test(key) ) 
              {
                 $scope.unitAxisMap[key.substring(5)] = parseInt($location.search()[key]);
              }
           });

           var ntvMap = {},
               notes = reportChartInputs ? reportChartInputs.notes : results[0].data._embedded.notes,
               numData = 0;

           notes.forEach(function(note) {
              note.templateValues.forEach(function(ntv) {
                 if(!ntvMap[ntv.templateSegmentId])
                    ntvMap[ntv.templateSegmentId] = [];

                 if (reportChartInputs)
                     ntv.noteURL = note._links.self.href;

                 ntvMap[ntv.templateSegmentId].push(ntv);
              });
           });

            $scope.segmentPromise.then(function() {
               for( var i=0; i < ts.length; i++ )
               {
                  if (!$scope.segmentMap[ts[i]])
                  {
                      // Remove segment from selected segments if it is not found in segment map
                      var index = $scope.selectedSegments.findIndex(function(id){ return id === ts[i]; });
                      $scope.selectedSegments.splice(index, 1);
                      continue;
                  }
                  var values =  ntvMap[ts[i]];
                  if( !values )
                     values = [];
                  numData += values.length;
                  var label;
                  if (reportChartInputs) {
                     var rve = reportChartInputs.reportViewEntries.find(function(rve) {
                        return rve.templateSegment && rve.templateSegment.id === ts[i];
                     });
                     label = rve.name || rve.templateSegment.longName;
                     if (rve.name)
                        $scope.customLabels[ts[i]] = rve.name;
                  } else
                     label = $scope.segmentMap[ts[i]].longName;
                  var axis = $scope.getAxis([ts[i]]);
                  $scope.segmentColors[ts[i]] = colors(i,i);
                  var dataSeries = $scope.getDataSeries(
                     label,
                     values,
                     $scope.segmentMap[ts[i]].type.name,
                     axis,
                     null,
                     $scope.segmentMap[ts[i]],
                     $scope.segmentColors[ts[i]]);
                  $scope.dataSeries[ts[i]] = dataSeries;
                  $scope.chartData.splice(0,0,dataSeries);
                  if( dataSeries.type == 'line' )
                     $scope.fillTimestamps(dataSeries);
               }
               $scope.setupAxes();
               $scope.init = true;
               if( numData == 0 )
                  $timeout(function() {
                     $scope.chart.update();
                  });
            });
        });
     };

     if ($scope.$parent.runChartQueries)
         $scope.$parent.runChartQueries = $scope.runQueries;

     $scope.calculateHeight = function(numText, onlyText)
     {
        if( onlyText )
           return Math.max(400, numText * 30);
        else
           return 400 + 30 * numText;
     };
     $scope.setChartHeight = function() 
     {
        $scope.chart.height($scope.chartHeight);
        $scope.svg.style({"height": $scope.chartHeight+'px'});
     };
     
     $scope.getAxisTooltip = function(segmentId, axis)
     {
        var currentAxis = $scope.getAxis(segmentId);
        var res = '<div>';
        if( $scope.axes[segmentId] )
           res += 'This data series has been explicitly placed on the ';
        else
           res += 'This data series has been placed by default on the ';
        
        res += currentAxis == 1 ? 'left' : 'right';
        res +=' axis.';
        res += '</div>';
        
        if( $scope.axes[segmentId] != axis )
        {
           res += '<div style="margin-top: .5em;">';
           if( axis != null && axis != currentAxis )
           {
              res += 'Click here to move it to the ';
              res += axis == 1 ? 'left' : 'right';
              res += ' axis.';
           }
           else if( axis != null && axis == currentAxis && !$scope.axes[segmentId])
           {
              res += 'Click here to make this setting explicit.';
           }
           else if( axis == null )
           {
              res += 'Click here to return it to the default axis.';
           }
           res += '</div>';
        }
        return res;
     };
     
     $scope.setSegmentAxis = function(segmentId, axis, setDefault)
     {
        if( !setDefault && $scope.axes[segmentId] == axis )
           return;
        
        if( !setDefault )
           $scope.axes[segmentId] = axis;
        else
           $scope.unitAxisMap[$scope.segmentMap[segmentId].units] = axis;
        $(".tooltip").tooltip('hide');
        $scope.updateSearch();
        $scope.runQueries();
        $scope.removeChartIfAllCleared();
     };
     $scope.getAxis = function(segmentId)
     {
        var segmentObj = $scope.segmentMap[segmentId];
        if( $scope.axes[segmentId] )
        {
           //console.log("using explicit axis for " + segmentObj.longName);
           return $scope.axes[segmentId];
        }
        var retval = null;
        if( $scope.segmentMap[segmentId] && $scope.segmentMap[segmentId].type.name != 'Numeric Input')
           retval = 1;
        else
           for( var i=0; i < $scope.segments.length; i++ )
           {
              var segment = $scope.segments[i];
              if( segmentObj && segmentObj.longName.indexOf($scope.segmentMap[segment.id].longName) == 0 )
              {
                 /*console.log("found match " + $scope.segmentMap[segmentId].longName
                       + ' ___ ' + segmentObj.longName
                       + ", scope.axes=" + $scope.axes[segment.id]
                       + ', retval='+retval);*/
                 retval = $scope.axes[segment.id] || retval;
                 if( segmentObj.id == segment.id )
                    break;
              }
           }
        if( !retval && segmentObj )
        {
           if( segmentObj.units && $scope.unitAxisMap[segmentObj.units] )
           {
              //console.log("matching on units for " + segmentObj.longName);
              retval = $scope.unitAxisMap[segmentObj.units];
           }
        }
        if( !retval ) retval = 1;
        //console.log("using axis " + retval + ' for ' + segmentId);
        return retval;
     }
     $scope.setupAxes = function()
     {
        var yAxisLabel = {};
        yAxisLabel[1] = '';
        yAxisLabel[2] = '';
        var units = {1: {}, 2: {}};
        var numTs = {1: 0, 2: 0};
        var numText = {1: 0, 2: 0};
        var minValues = {1:9999999999, 2:9999999999};
        var maxValues = {1:-9999999999, 2:-9999999999};
        for( var i=0; i < $scope.chartData.length; i++ )
        {
           var segUnits = $scope.chartData[i].segment.units;
           var axis = $scope.chartData[i].yAxis;
           numTs[axis]++;
           if( $scope.chartData[i].type != 'line' )
              numText[axis]++;
           if( segUnits && !units[axis][segUnits])
           {
              units[axis][segUnits] = true;
              yAxisLabel[axis] += (yAxisLabel[axis].length ? ', ' : '') + segUnits;
           }
           $scope.chart.yAxis1.axisLabel(yAxisLabel[1]);
           $scope.chart.yAxis2.axisLabel(yAxisLabel[2]);
           
           if( $scope.chartData[i].type == 'line' )
           {
              for( var j=0; j < $scope.chartData[i].values.length; j++ )
              {
                 minValues[axis] = Math.min($scope.chartData[i].values[j].value, minValues[axis]);
                 maxValues[axis] = Math.max($scope.chartData[i].values[j].value, maxValues[axis]);
              }
           }
        }
        var noOtherValues = {1: false, 2:false};
        var onlyText = {1: false, 2:false};
        for( var axis = 1; axis <= 2; axis++ )
        {
           if( maxValues[axis] == -9999999999 )
           {
              maxValues[axis] = Math.max(1, maxValues[2]);
              minValues[axis] = 0;
              noOtherValues[axis] = true;
              onlyText[axis] = true;
           }
        }
        $scope.maxValues = angular.extend({}, maxValues);
        $scope.minValues = angular.extend({}, minValues);
        
        for( var i = 0; i < $scope.chartData.length; i++ )
        {
           var axis = $scope.chartData[i].yAxis;
           var val = maxValues[axis];
           var testDataSeries = $scope.chartData[i];
           if( testDataSeries.type != 'line' )
           {
              val = val + ($scope.maxValues[axis] - minValues[axis])*.05
                 + (onlyText[axis] ? 1 : 0);
              maxValues[axis] = val;
              noOtherValues[axis] = false;
              for( var j=0; j < testDataSeries.values.length; j++ )
                 testDataSeries.values[j].value = val;
           }
        }
        maxValues[2] *= (.05+maxValues[1]/$scope.maxValues[1]);
        for( var axis = 1; axis <= 2; axis++ )
        {
           $scope.chart['yDomain'+axis]([minValues[axis], maxValues[axis] + (onlyText[axis] ? 1 : 0)]);
        }
        
        $scope.chartHeight = Math.max(
              $scope.calculateHeight(numText[1], onlyText[1] && onlyText[2]),
              $scope.calculateHeight(numText[2], onlyText[1] && onlyText[2]));
        $scope.setChartHeight();

     }
     $scope.getAbnormalText = function(segment, value)
     {
           if( segment && segment.type && segment.type.name == 'Text Choice' 
              && $scope.abnormalChoices[segment.choiceList.id])
              return $scope.abnormalChoices[segment.choiceList.id][value]
                 ? 'This value is abnormal.'
                 : null;
           
           if( segment && segment.type && segment.type.name == 'Numeric Input')
           {
              if( segment.minValue != null && value < segment.minValue )
                 return 'Normal minimum value: ' + segment.minValue;
              if( segment.maxValue != null && value > segment.maxValue )
                 return 'Normal maximum value: ' + segment.maxValue;
           }
     }
     
     $scope.fillTimestamps = function(dataSeries)
     {
        for( var i=0; i < $scope.timestamps.length; i++ )
        {
           var j=0;
           var timestamp = $scope.timestamps[i].timestamp;
           while(j < dataSeries.values.length-1 &&  dataSeries.values[j].date < timestamp)
           {
              j++;
           }
           if( dataSeries.values.length == 0 || dataSeries.values[j].date > timestamp)
           {
              var val = null;
              var tsId = null;
              if( j < dataSeries.values.length-1 && j > 0 )
              {
                 var prevTime = dataSeries.values[j-1].date;
                 var nextTime = dataSeries.values[j].date;
                 var prevVal = dataSeries.values[j-1].value;
                 var nextVal = dataSeries.values[j].value;
                 var pct = (timestamp-prevTime)/(nextTime-prevTime);
                 val = prevVal + (nextVal-prevVal)*pct;
                 tsId = dataSeries.values[j-1].tsId;
              }
              dataSeries.values.splice(j, 0, {
                 'noteHref': $scope.timestamps[i].noteHref,
                 'tsId':  tsId,
                 'synthesized': true,
                 'date': timestamp, 
                 'value': val
              });
           }
           else if( j == dataSeries.values.length-1 )
              dataSeries.values.push({'date': timestamp, 'value':null});
        }
     };
     
     $scope.toggleSection = function(sectionId)
     {
        var section = $scope.segmentMap[sectionId];
        var removedSection = $scope.removedSections[sectionId];
        delete $scope.removedSections[sectionId];
        var toggle = [];
        if( !removedSection )
        {
           for( var i=0; i < $scope.chartData.length; i++ )
           {
              if( $scope.chartData[i].segment.longName.indexOf( section.longName ) == 0 )
                 toggle.push($scope.chartData[i].segment.id);
           }
           $scope.removedSections[sectionId] = section;
        }
        else
        {
           Object.keys($scope.removedSeries).forEach(function(key) {
              if( $scope.removedSeries[key].segment.longName.indexOf( section.longName ) == 0 )
                 toggle.push($scope.removedSeries[key].segment.id);
           });
        }
        $timeout(function() {
           toggle.forEach(function(id) {
              $scope.toggleDataSeries(id, true);
           });
           $scope.setupAxes();
           $scope.removeChartIfAllCleared();
           $scope.chart.update();
        });
     };
     
     $scope.toggleDataSeries = function(segmentId, skipChartUpdate)
     {
        var removedSeries = $scope.removedSeries[segmentId];
        delete $scope.removedSeries[segmentId];
        if( !removedSeries )
           $scope.removedSeries[segmentId] = true;
        var doUpdate = function() {
           for( var i=0; i < $scope.chartData.length; i++ )
              if( removedSeries && $scope.chartData[i].segment.sortOrder < removedSeries.segment.sortOrder )
              {
                 $scope.chartData.splice(i, 0, removedSeries);
                 removedSeries = null;
                 break;
              }
              else if($scope.chartData[i].segment.id == segmentId )
              {
                 $scope.removedSeries[segmentId] = $scope.chartData[i];
                 $scope.chartData.splice(i,1);
                 break;
              }
           if( removedSeries )
              $scope.chartData.push(removedSeries);
           if( !skipChartUpdate )
           {
              $scope.setupAxes();
              $scope.removeChartIfAllCleared();
              $scope.chart.update();
           }
        };
        if( skipChartUpdate )
           doUpdate();
        else
           $timeout(doUpdate);
     };
     
     $scope.removeChartIfAllCleared = function()
     {
        ['scatter','line'].forEach(function(type) {
           var found = {1: false, 2:false};
           for( var i=0; i < $scope.chartData.length; i++ )
           {
              if( $scope.chartData[i].type == type )
                 found[$scope.chartData[i].yAxis] = true;
           }
           [1,2].forEach(function(axis) {
              if( !found[axis] )
                 $scope.svg.selectAll('.'+type+'s'+axis+'Wrap path').remove();
           });
        })
     }
     
     $scope.getDataSeries = function(key, data, segmentType, yaxis, type, segment, color)
     {
        if( $scope.chartTitle.length > 3 && !$scope.report )
           key = key.substring($scope.chartTitle.length-1)
        var shapes = [
           'triangle-up', 
           'triangle-down', 
           'triangle-right',
           'triangle-left',
           'cross', 
           'star',
           'square', 
           'circle',
           'wye',
           'x'
        ];
        var shapeI = 0;
        var shapeMap = {};
        var abShapeI = shapes.length-1;
        return {
           'key' : key,
           'type' : segmentType == 'Numeric Input' ? 'line' : 'scatter',
           'yAxis' : segmentType == 'Numeric Input' ? yaxis : 1,
           'segment' : segment,
           'color': color,
           'values' : data.map(function(d) {
              var res = {};
              res['date'] = new Date(d.noteTime.replace(/\+0000/,'Z'));
              res['value'] = segmentType == 'Numeric Input' ? d['numericValue'] : 100;
              if( segmentType == 'Checkbox' )
              {
                 if( d['stringValue'] == 'checked' )
                    res['stringValue' ] = '☑';
                 else if( d['stringValue'] == 'unchecked' )
                    res['stringValue' ] = '☐';
              }
              else if( segmentType == 'User Chooser' && d['userValue'])
              {
                 res['stringValue'] = d['userValue'].firstName + ' ' + d['userValue'].lastName;
              }
              else if( segmentType == 'Signoff' && d['booleanValue'] != null )
              {
                 res['stringValue'] = (d['booleanValue'] ? 'Signed Off' : 'Rejected')
                    + ' by ' + d['userValue'].firstName + ' ' + d['userValue'].lastName;
              }
              else if( segmentType == 'Tag Choice' )
              {
                 res['stringValue'] = $filter('orderBy')(d['tagValues'], 'viewString')
                 .map(function(v) { return v.viewString;})
                 .join(', ');
              }
              else if( segmentType == 'Numeric Input' )
                 res['stringValue'] = d['numericValue'];
              else if( segmentType == 'Text Choice' )
                 res['stringValue'] = d['stringValue'];

              res['comment'] = d['comment'];
              res['commentAttachments'] = d['commentAttachments'];
              res['tsId'] = d['templateSegmentId'];
              res['noteHref'] = d.noteURL || $scope.noteMap[d['noteId']]._links.self.href;
              res['type'] = segmentType == 'Numeric Input' ? 'line' : 'scatter';
              res['shape'] = 
                 (d['comment'] && d['comment'].length)
                 || (d['commentAttachments'] && d['commentAttachments'].length)
                 ? 'diamond'
                 : 'circle';

              var abnormal = $scope.getAbnormalText(segment, 
                 d[segmentType == 'Numeric Input' ? 'numericValue' : 'stringValue']);
              if( abnormal )
                 res['abnormal'] = abnormal;
              if( segmentType != 'Numeric Input' )
              {
                 if( abnormal && !shapeMap[res['stringValue']])
                    shapeMap[res['stringValue']] = shapes[abShapeI-- % shapes.length];
                 else if( !shapeMap[res['stringValue']])
                    shapeMap[res['stringValue']] = shapes[shapeI++ % shapes.length];
                 res['shape'] = shapeMap[res['stringValue']];
              }
              return res;
             })};
     };
     
     $scope.checkForComments = function() {
        $timeout(function() {
           $scope.svg.selectAll('path')
              .attr("data-has-comment", function(d) {
                 if( typeof(d) == 'object' && d[0] &&
                 ((d[0].comment && d[0].comment.length)
                   ||(d[0].commentAttachments && d[0].commentAttachments.length)))
                    return 'true';
              })
             .attr("data-abnormal", function(d) {
                if( typeof(d) == 'object' && d[0] &&
                      d[0].abnormal )
                   return d[0].type;
             }
             );
           $scope.svg.selectAll('.nv-axis').attr('fill', 
                 $('#chart-title').css('color'));
        });
     };
     
     $scope.onReady = function(scope) {
        $scope.chart = scope.chart;
        if ($scope.$parent.chart)
            $scope.$parent.chart = scope.chart;
        $scope.svg = scope.svg;
        $scope.api = scope.api;

        ['lines1','lines2','scatters1','scatters2'].forEach(function(key) {

           $scope.chart[key].dispatch.on('elementClick', function(e) {
              $scope.openNote(e.point.noteHref, e.point.tsId);
           });
           
           $scope.chart[key].dispatch.on('renderEnd', function(e) {
              $scope.checkForComments();
           });

        });
           
        $scope.chart.scatters1.pointRange([30,30]);
        $scope.chart.scatters2.pointRange([30,30]);
        $scope.setChartHeight();
        if ($location.search()['report'])
            $scope.chart.noData('No chartable elements.');
        
     };
     $scope.openNote = function(href, segment) {
        $location.url('/note-detail')
           .search('note', href)
           .search('scrollToSegment', segment);
        $scope.$apply();
     }
     
     $scope.getDisplayName = function(segment)
     {
        return segment.longName 
           + (segment.units ? ' ('+segment.units+')' : '')
           + (segment.choiceList ? ' ('+segment.choiceList.name+')' : '');
     };
     
     $scope.calculateTickFormat = function(d, axis)
     {
         var range = $scope.maxValues[axis] - $scope.minValues[axis];
         var decimals = 0;

         if( range < .0001 )
             decimals = 5;
         else if( range < .001 )
             decimals = 4;
         else if( range < .01 )
             decimals = 3;
         else if( range < .1 )
             decimals = 2;
         else if( range < 3 )
             decimals = 1;
         
         return d > $scope.maxValues[axis] ? '' : $filter('number')(d, decimals);
     };
     $scope.chartOptions = {
          chart: {
             type: 'multiChart',
             margin : {
                 top: 50,
                 right: 50,
                 bottom: 50,
                 left: 55
             },
             transitionDuration: 500,
             defined: function(d) {
                return d.value != null;
             },
             legend: {
                maxKeyLength: 100
             },
             useVoronoi: false,
             scatters1: {
                useVoronoi: false
             },
             scatters2: {
                useVoronoi: false
             },
             tooltip: {
                contentGenerator: function(d) {
                    var segment = $scope.segmentMap[d.point.tsId];
                    var abnormal = d.point.abnormal;
                    var res = '<div style="padding: 5px;">'
                    + '<div style="font-weight: bold;">'
                    + $filter('date')(d.point.date, 'MM-dd-yy HH:mm') + '</div> '
                    + $sanitize(escapeHtml(d.series[0].key + ': ' 
                          + ((d.point.synthesized || (d.point.value == null && d.point.stringValue == null))
                                ? 'No Value' 
                                : (d.point.stringValue != null ? d.point.stringValue : d.point.value) 
                                   +' '+ (segment.units||''))));
                    
                    if( abnormal )
                       res += '<div>' + $sanitize(escapeHtml(abnormal)) + "</div>";
                    if( d.point.comment )
                       res += '<div style="margin-top: 5px;">' + $sanitize(escapeHtml(d.point.comment)) + '</div>';
                    if( d.point.commentAttachments && d.point.commentAttachments.length )
                    {
                       var att = d.point.commentAttachments;
                       for( var i=0; i < att.length; i++ )
                          res += '<img src="/api/files/'+att[i].id+'?scale-height=200">';
                       }
                    res += '</div>';
                    return res;
                }
            },
            x: function(d){ 
                return new Date(d.date); 
                },
             y: function(d){ 
                return d.value;
                },
             xAxis: {
                axisLabel: 'Date',
                tickFormat: function(d) { return $filter('date')(new Date(d), 'MM-dd-yy');}
             },
             showLegend: false,
             legendRightAxisHint: '',
             yAxis1: {
                axisLabelDistance: -8,
                tickFormat: function(d) { return $scope.calculateTickFormat(d, 1); }
             },
             yAxis2: {
                axisLabelDistance: -25,
                tickFormat: function(d) { return $scope.calculateTickFormat(d, 2); }
             }
          }
        };

  }]);
